import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import { createLotType, deleteLotType, getLotTypes, updateLotType } from './lotTypes.actions';
import { LotType } from './lotTypes.types';

export type LotTypesState = LotType[];

const initialState: LotTypesState = [];

const lotTypesReducer = createReducer(initialState, {
  [getLotTypes.done.type]: (_state: LotTypesState, action: ReturnType<typeof getLotTypes.done>) => {
    return action.payload.result;
  },
  [createLotType.done.type]: (state: LotTypesState, action: ReturnType<typeof createLotType.done>) => {
    return [...state, action.payload.result];
  },
  [updateLotType.done.type]: (state: LotTypesState, action: ReturnType<typeof updateLotType.done>) => {
    const updatedLotType = action.payload.result;
    const indexFound = state.findIndex((lotType) => lotType.id === updatedLotType.id);
    return dotProp.set(state, indexFound, updatedLotType);
  },
  [deleteLotType.done.type]: (state: LotTypesState, action: ReturnType<typeof deleteLotType.done>) => {
    const deletedLotTypeId = action.payload.result;
    const indexFound = state.findIndex((lotType) => lotType.id === deletedLotTypeId);
    return dotProp.delete(state, indexFound);
  },
});

export default lotTypesReducer;
